import { billingRequest } from "./billing-client";

export interface TenantSettingsResponse {
  tenant: {
    id: string;
    slug: string;
    name: string;
    currency: string;
    locale: string;
    timezone: string;
  };
  settings: Record<string, unknown>;
}

export const settingsApi = {
  get: () => billingRequest<TenantSettingsResponse>("/settings"),
  upsert: (key: string, value: Record<string, unknown>) =>
    billingRequest<{ id: string; key: string; value: unknown }>("/settings", {
      method: "PATCH",
      body: JSON.stringify({ key, value }),
    }),
};
